import firebase from '../../firebase/firebase';
import { httpsCallable } from "@/firebase/functions";

const defaultAddress = {
    logradouro : '',
    bairro : '',
    numero : '',
    municipio : '',
    uf : 'ES',
    cep : '',
    complemento: ''
}

const defaultPayment = {
    paymentType: 'credit_card',
    phoneNumber: '',
    obs: '',
    changeFor: null,
}

export default {
    namespaced: true,

    state: {
        isDelivery: true,
        orders: [],
        clientName: '',
        deliveryAddress: {
            ...defaultAddress
        },
        payment: {
            ...defaultPayment
        },
    },

    getters: {
        ordersValue: (state) => state.orders.reduce((prev, curr) => prev + curr.value, 0)
    },

    actions: {
        async sendDeliveryOrder ({ state, rootGetters, commit }) {
            const orderDeliveryByDash = httpsCallable('orderDeliveryByDash');
            const order = {
                companyId: rootGetters.getCompanyID,
                orders: state.orders,
                payment: state.payment,
                toDeliver: state.isDelivery,
                clientName: state.clientName
            };
            if (state.isDelivery) {
                order.addressData = {
                    cep: state.deliveryAddress.cep,
                    number: state.deliveryAddress.numero,
                    street: state.deliveryAddress.logradouro,
                    neighborhood: state.deliveryAddress.bairro,
                    city: state.deliveryAddress.municipio,
                    complement: state.deliveryAddress.complemento,
                };
            }
            await orderDeliveryByDash(order);
            commit('clearUp');
        }
    },

    mutations: {
        clearUp (state) {
            state.orders = [];
            state.isDelivery = true;
            state.clientName = '';
            state.deliveryAddress = { ...defaultAddress };
            state.payment = { ...defaultPayment };
        },
        addToDelivery (state, order) {
            state.orders.push(order);
        },
        setAddress (state, addr) {
            state.deliveryAddress = addr;
        },
        setIsDelivery (state, isDeliver) {
            state.isDelivery = isDeliver;
        },
        setClientName (state, value) {
            state.clientName = value;
        },
        setClientTelephone (state, value) {
            state.payment.phoneNumber = value;
        },
        setPaymentType (state, value) {
            state.payment.paymentType = value;
        },
        setChange (state, value) {
            state.payment.changeFor = value;
        },
        setObs (state, value) {
            state.payment.obs = value;
        },
        removeItem(state, order) {
            state.orders = state.orders.filter(o => o != order);
        },
    }
}
